import { render, staticRenderFns } from "./JanelaDeNotificacao.vue?vue&type=template&id=41fc4251&scoped=true"
import script from "./JanelaDeNotificacao.vue?vue&type=script&lang=js"
export * from "./JanelaDeNotificacao.vue?vue&type=script&lang=js"
import style0 from "./JanelaDeNotificacao.vue?vue&type=style&index=0&id=41fc4251&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fc4251",
  null
  
)

export default component.exports